module.exports = __webpack_public_path__ + "school/img/fuwuqi2.de54cc31.jpg";